module.exports = __webpack_public_path__ + "prod/1.42.2/img/logo_two2x.597add5f.png";